<!--Als großer Button am unteren Bildschirmrand-->
<template>
  <div>
    <div v-if="!hideBasket">
      <div v-if="isHighScreen">
        <KioskBasketButton></KioskBasketButton>
      </div>

      <div v-else class="fixBasket">
        <!--        <div class="tablet fixBasket pointer"-->
        <!--             v-if="$store.getters.cartItems.length > 0" @click.passive="gotoCart">-->
        <v-container class="pointer cc checkoutButtonAnimation" v-if="itemsCount > 0" @click.passive="gotoCart">
          <!--            <v-badge-->
          <!--                    color="black"-->
          <!--                    dark-->
          <!--                    :content="itemsCount"-->
          <!--                    overlap-->

          <!--            >-->
          <!--                &lt;!&ndash;                offset-x="19"&ndash;&gt;-->
          <!--                &lt;!&ndash;                offset-y="19"&ndash;&gt;-->
          <!--                <v-btn icon>-->
          <!--                    <v-icon class="myWhite" medium>mdi-cart</v-icon>-->
          <!--                </v-btn>-->
          <!--            </v-badge>-->

          <div class="d-flex align-content-stretch">

            <div class="leftPart">
              <div class="maxh d-flex align-center">
                <div class="summe" v-if="!$store.getters.hidePrices">
                  {{ $store.getters.payerSum | price }}
                </div>
              </div>
            </div>


            <div class="rightPart">
              <div class="maxh d-flex justify-end align-center">
                <v-badge
                  color="black"
                  :content="itemsCount"
                  overlap
                  offset-x="20"
                  offset-y="20"
                  class="mr-1"
                >
                  <v-btn class="rounded100" icon @click.native.passive="gotoCart" dark block>
                    <v-icon left medium class="myWhite">mdi-cart-arrow-right</v-icon>
                  </v-btn>
                </v-badge>
                <div class="titleFont biggerFont ml-2 mr-1 baseColor ccPulsing">CHECKOUT</div>
                <v-icon medium class="baseColor myBase flex-shrink-0">mdi-chevron-right</v-icon>
              </div>
            </div>
          </div>


        </v-container>

        <!--            <v-icon color="white" medium>mdi-cart-arrow-right</v-icon>-->
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store/store'
import KioskBasketButton from "./KioskBasketButton.vue";
import * as qconst from "../vendor/qconstants";
//
export default {
  components: {KioskBasketButton},
  //     name: "FixBasket",
  //     data: () => ({
  //         showTip: false,
  //     }),
  data: () => ({
      isHighScreen: false,
    }
  ),
  mounted() {
    this.updateIsHighScreen();
  },
  beforeMount() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    itemsCount() {
      let i = 0;
      for (let item of store.getters.cartItems) {
        if (item.id.startsWith('special') || item.id.startsWith('stempel-')) {
          continue;
        }
        i += item.count;
      }
      return '' + i;
    },
    hideBasket() {
      return store.getters.showItemAdditionals;
    },
  },
  methods: {
    handleResize() {
      setTimeout(() => {
        this.updateIsHighScreen();
      }, 400);
    },
    updateIsHighScreen() {
      this.isHighScreen = document.body.classList.contains('highScreen');
    },
    gotoCart() {
      this.$router.push({name: 'Korb'});
    },
  }
  //
}
</script>

<style lang="scss" scoped>
@import '../styles/base';

$baseColor: white; //$font-color
.baseColor {
  color: darken($baseColor, 15%); //$font-color $baseColor
}

.baseColor.myBase {
  color: $baseColor;
}

.summe {
  font-size: 1.1em;
  font-weight: bold;
  text-align: left;
  padding-left: 0.5vw;
  color: $baseColor;
}

.leftPart {
  flex: 1 1 30%;
  height: auto;
}

.rightPart {
  flex: 1 0 70%;
  margin-left: 20px;
  height: auto;
}

.cc {
  //max-height: 48px;
  //background-color: $accent; //$color-darkblue;
  border-radius: $button-border-radius;
  padding: 15px 2vw 15px 2vw
}

.fixBasket {
  z-index: 200;
  text-align: center;
  position: fixed;
  right: 0;
  bottom: 0;
  //width: 100%;
  color: white;
  //@include text-contrast($accent);
  padding: 0 10px 10px 10px;
  /*padding: 15px 15px 15px 30px;*/
  /*clip-path: polygon( 30% 0, !* left top *! 100% 0, !* right top *! 100% 100%, !* right bottom *! 0 100% !* left bottom *! );*/
  /*clip-path: polygon( 0 0, !* left top *! 100% 0, !* right top *! 100% 80%, !* right bottom *! 0 100% !* left bottom *! );*/
}

////////////////////////
.ccPulsing {
  /*transform-style: preserve-3d;*/
  /*backface-visibility: hidden;*/
  /*will-change: transform;*/
  /*animation: pulse 1s infinite;*/
  /*>>> .v-btn__content {*/
  animation: ccPulse linear 0.6s infinite;
  /*}*/
}

@keyframes ccPulse {
  from {
    color: default;
  }
  50% {
    color: lighten($baseColor, 15%);
  }
  to {
    color: default;
  }
}
</style>
